// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import {
  NewTruckingType,
  TruckingType,
  type TruckingTypeWireFormat,
} from '../TruckingType/TruckingType';

export class ProjectProductTruckingInfo {
  readonly id: string;
  readonly truckingType: TruckingType;
  readonly haulRate: Currency | null;
  readonly minimumHaulCharge: number | null;
  readonly taxRate: string | null;
  readonly haulTaxable: boolean;
  readonly haulCost: Currency | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.truckingType = NewTruckingType(data.truckingType);
    this.haulRate = (data.haulRate ?? null) === null ? null : NewCurrency(data.haulRate);
    this.minimumHaulCharge = data.minimumHaulCharge === undefined ? null : data.minimumHaulCharge;
    this.taxRate = data.taxRate === undefined ? null : data.taxRate;
    this.haulTaxable = data.haulTaxable === undefined ? false : data.haulTaxable;
    this.haulCost = (data.haulCost ?? null) === null ? null : NewCurrency(data.haulCost);
  }

  static zero(): ProjectProductTruckingInfo {
    const zeroValues: ExcludeMethodsDeep<ProjectProductTruckingInfo> = {
      id: NIL_UUID,
      truckingType: TruckingType.zero(),
      haulRate: null,
      minimumHaulCharge: null,
      taxRate: null,
      haulTaxable: false,
      haulCost: null,
    };
    return new ProjectProductTruckingInfo(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectProductTruckingInfoWireFormat = {
  id: string;
  truckingType: TruckingTypeWireFormat;
  haulRate: CurrencyWireFormat | null;
  minimumHaulCharge: number | null;
  taxRate: string | null;
  haulTaxable: boolean;
  haulCost: CurrencyWireFormat | null;
};

type NewProjectProductTruckingInfoProps = PartialDeep<
  ProjectProductTruckingInfo,
  { recurseIntoArrays: true }
>;
export const NewProjectProductTruckingInfo: (
  props: NewProjectProductTruckingInfoProps,
) => ProjectProductTruckingInfo = (props) => new ProjectProductTruckingInfo(props);

type NewProjectProductTruckingInfoFromWireFormatProps = PartialDeep<
  ProjectProductTruckingInfoWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectProductTruckingInfoFromWireFormat: (
  props: NewProjectProductTruckingInfoFromWireFormatProps,
) => ProjectProductTruckingInfo = (props) => new ProjectProductTruckingInfo(props);
